import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle navigation - scroll to section if on homepage, navigate if not
    const handleNavClick = (sectionId) => {
        setIsMenuOpen(false);

        if (location.pathname === '/') {
            // Already on homepage, just scroll
            const element = document.getElementById(sectionId);
            if (element) {
                const navHeight = 80;
                const targetPosition = element.offsetTop - navHeight;
                window.scrollTo({ top: targetPosition, behavior: 'smooth' });
            }
        }
        // If not on homepage, Link will navigate to /#section and HomePage will handle scroll
    };

    return (
        <nav className={`navbar navbar-expand-lg navbar-custom fixed-top ${isScrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <Link className="navbar-brand d-flex align-items-center gap-3" to="/">
                    <img
                        src="/images/vgw-logo.png"
                        alt="Vintage Glass Works"
                    />
                    <span className="nav-tagline d-none d-sm-inline">Vintage Glass Works</span>
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse justify-content-end ${isMenuOpen ? 'show' : ''}`}>
                    <ul className="navbar-nav align-items-lg-center gap-lg-2">
                        <li className="nav-item">
                            <Link
                                className="nav-link nav-link-custom"
                                to="/#services"
                                onClick={() => handleNavClick('services')}
                            >
                                Services
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link nav-link-custom"
                                to="/#portfolio"
                                onClick={() => handleNavClick('portfolio')}
                            >
                                Portfolio
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link nav-link-custom"
                                to="/#about"
                                onClick={() => handleNavClick('about')}
                            >
                                About
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link nav-link-custom"
                                to="/#process"
                                onClick={() => handleNavClick('process')}
                            >
                                Process
                            </Link>
                        </li>
                        <li className="nav-item ms-lg-3">
                            <Link
                                className="nav-link btn-nav-cta"
                                to="/#contact"
                                onClick={() => handleNavClick('contact')}
                            >
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;